import React from 'react'

export default function Layouts404() {
  return (
    <section><a className="anchor" id="notfound"></a>
      <div className="push--bottom grid">
          <div className="grid__col-sm-12  grid__col-lg-6">
              <a href="samples/notfound.html"><img src="images/notfound.png" alt="Screenshot of the theme snippet" className="media__img"/></a>
          </div>
          <div className="media__body soft--top grid__col-sm-12 grid__col-lg-6">
            <h2>404 Error</h2>
            <p>Live example of all the 404 error page.</p>
            <p><a className="btn btn--large" href="samples/notfound.html">View live preview</a>&nbsp;<a className="btn btn--large" href="samples/notfound.html" download>Download</a></p>
          </div>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./styleguide/components/sections/Layouts404.js